import React from 'react';
import { FormGroup, FormControl, Button, Row, Col } from 'react-bootstrap';

export default function ApprovalLevelApprovers({
    level,
    approverIds = [],
    users = [],
    loading = false,
    canRemove = false,
    onToggleApprover,
    onRemoveLevel,
}) {
    const selectedIds = new Set((approverIds || []).map((id) => String(id)));
    const selectedUsers = users.filter((user) => selectedIds.has(String(user.id)));

    return (
        <FormGroup style={{ marginBottom: '15px' }}>
            <Row>
                <Col sm={2}>
                    <strong>Level {level.level}</strong>
                </Col>
                <Col sm={8}>
                    <div
                        style={{
                            border: '1px solid #ced4da',
                            borderRadius: '4px',
                            padding: '10px',
                            maxHeight: '220px',
                            overflowY: 'auto',
                            background: '#fff',
                        }}
                    >
                        {users.length === 0 ? (
                            <small className="text-muted">No approvers available</small>
                        ) : (
                            users.map((user) => {
                                const userId = String(user.id);
                                const checked = selectedIds.has(userId);
                                const label = `${user.username}${user.firstName || user.lastName ? ` (${user.firstName || ''} ${user.lastName || ''})`.trim() : ''}${user.email ? ` - ${user.email}` : ''}`;
                                return (
                                    <label
                                        key={user.id}
                                        style={{ display: 'block', marginBottom: '8px', cursor: loading ? 'not-allowed' : 'pointer' }}
                                    >
                                        <input
                                            type="checkbox"
                                            checked={checked}
                                            disabled={loading}
                                            onChange={() => onToggleApprover(userId)}
                                            style={{ marginRight: '8px' }}
                                        />
                                        {label}
                                    </label>
                                );
                            })
                        )}
                    </div>
                    {selectedUsers.length > 0 ? (
                        <small className="text-muted" style={{ display: 'block', marginTop: '8px' }}>
                            Notifications will be sent to:{' '}
                            {selectedUsers
                                .map((user) => user.email || user.username)
                                .filter(Boolean)
                                .join(', ')}
                        </small>
                    ) : (
                        <small className="text-warning" style={{ display: 'block', marginTop: '8px' }}>
                            Select at least one approver for this level.
                        </small>
                    )}
                </Col>
                <Col sm={2}>
                    {canRemove && (
                        <Button
                            variant="danger"
                            size="sm"
                            onClick={onRemoveLevel}
                            disabled={loading}
                        >
                            Remove
                        </Button>
                    )}
                </Col>
            </Row>
        </FormGroup>
    );
}
